
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetShowersPolartwilight as ObiHeavySleetShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-showers-polartwilight.js';
 
 
 

 
 export const ObiHeavySleetShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-showers-polartwilight',
   elementClass: ObiHeavySleetShowersPolartwilightElement,
   events: {
     
   }
  });
 
 